import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { ContextService } from 'src/app/services/context/context.service';
import { SUPPRESS_ERROR_CODES } from 'src/app/utils';
import { IPage, DeleteResult } from 'src/app/xena-api';



@Injectable({
  providedIn: 'root',
})

export class XenaClient {
  constructor(private http: HttpClient, private context: ContextService) { }

  list<T, TFilter = null>(path: string, filter: TFilter = null, options?: Options): Observable<IPage<T>> {
    const url = this.buildUrl(path);
    let params = options?.params instanceof HttpParams ? options.params : new HttpParams({ fromObject: options?.params });
    if (filter !== null) {
      Object.keys(filter).forEach((key) => {
        params = params.append(key, filter[key]);
      });
    }

    return this.http.get<IPage<T>>(url, { ...options, params }).pipe(share());
  }

  get<T>(path: string, options?: Options): Observable<T> {
    let context = options?.context instanceof HttpContext ? options.context : new HttpContext();

    context = context.set(SUPPRESS_ERROR_CODES, new Set([404]));

    return this.http.get<T>(this.buildUrl(path), { ...options, context }).pipe(
      catchError((error: { status: number }) => error.status === 404 ? of(null) : throwError(error)),
      share()
    );
  }

  post<T, R>(path: string, data: T, options?: Options): Observable<R> {
    return this.http.post<R>(this.buildUrl(path), data, { ...options }).pipe(share());
  }

  put<T, R>(path: string, data: T, options?: Options): Observable<R> {
    return this.http.put<R>(this.buildUrl(path), data, { ...options }).pipe(share());
  }

  delete(path: string, options?: Options): Observable<DeleteResult> {
    return this.http.delete<DeleteResult>(this.buildUrl(path), { ...options }).pipe(share());
  }

  private buildUrl(path: any) {
    return `${this.context.serviceUrl}${path}`;
  }
}

export interface Options {

  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  observe?: 'body';
  params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  context?: HttpContext;
}
